import locales from './../../content.json';

function localisation() {
    let localisationNodes = document.querySelectorAll('[data-i18n]');

    let lang = window.navigator.language.slice(0, 2);
    document.body.classList.add(lang);

    setLocalisation(lang);

    function setLocalisation(lang) {
        localisationNodes.forEach((node) => {
            let langID = node.dataset.i18n;
            let content = locales[lang][langID];

            node.innerHTML = content;
        });
    }
}

export default localisation;